import React from 'react';
import moment from 'moment';
import { Row, Col } from 'antd';
import { object, bool, func } from 'prop-types';

import { FormS } from './styled-components';
import { SvgIcon } from '../../../components/svg-icon';
import { FormItem, SelectS } from '../styled-components';
import { AssignButton } from '../../../components/ui-helpers';
import { ReactQuillWrapped } from '../../../components/react-quill';
import { DatePicker, TimePicker } from '../../../components/popovers';
import { disabledFutureDays, disabledFutureHours, disabledFutureMinutes, getCurrentUserId } from '../../../utils';

const MeetingNotesForm = ({
  form: { getFieldValue, getFieldDecorator },
  showForm,
  onAssignMeClick,
  participantsOptions,
  onParticipantSearch,
  setParticipantsOptions,
  isSearchingParticipants,
}) => (
  <FormS withoutOverflowY showForm={showForm}>
    <Row gutter={20}>
      <Col span={24}>
        <FormItem label="Text notes">
          {getFieldDecorator('text', {
            initialValue: '',
            rules: [
              {
                required: true,
                message: 'Please enter notes',
              },
            ],
          })(<ReactQuillWrapped
            height="280px"
            withPaddings
            placeholder="Enter text here"
            theme="snow"
            bounds="#text"
            scrollingContainer="#text"
          />)}
        </FormItem>
      </Col>

      <Col span={12}>
        <FormItem label="Date">
          {getFieldDecorator('date', {
            initialValue: moment(),
            rules: [
              {
                required: true,
                message: 'Please choose date',
              },
            ],
          })(<DatePicker disabledDate={disabledFutureDays} />)}
        </FormItem>
      </Col>
      <Col span={12}>
        <FormItem label="Time">
          {getFieldDecorator('time', {
            initialValue: moment(),
            rules: [
              {
                required: true,
                message: 'Please choose time',
              },
            ],
          })(<TimePicker
            style={{ width: '100%' }}
            {...((getFieldValue('date') &&
                moment(getFieldValue('date').startOf('day')).isSame(moment().startOf('day'))) ||
                !getFieldValue('date')) && {
              disabledHours: disabledFutureHours,
              ...(getFieldValue('time') &&
                moment(getFieldValue('time')).get('hour') === moment().get('hour')) && {
                disabledMinutes: disabledFutureMinutes,
              },
            }}
          />)}
        </FormItem>
      </Col>

      <Col span={24}>
        <AssignButton
          type="button"
          style={{ marginRight: '4px' }}
          disabled={getFieldValue('participants') && getFieldValue('participants').includes(getCurrentUserId())}
          onClick={() => onAssignMeClick(getCurrentUserId())}
        >
          <SvgIcon type="plus" /> Assign me
        </AssignButton>

        <FormItem label="Meeting participants:">
          {getFieldDecorator('participants', {
            rules: [
              {
                required: true,
                message: 'Please choose participants',
              },
            ],
          })(<SelectS
            mode="multiple"
            size="large"
            allowClear
            showSearch
            filterOption={false}
            notFoundContent={null}
            placeholder="Add participants"
            defaultActiveFirstOption={false}
            onSearch={onParticipantSearch}
            loading={isSearchingParticipants}
            onBlur={() => setParticipantsOptions({ contacts: [], users: [] })}
            getPopupContainer={triggerNode => triggerNode.parentNode}
          >
            {participantsOptions.contacts.length > 0 && (
              <SelectS.OptGroup label="Contacts">
                {participantsOptions.contacts.map(({ _id, fullName }) => (
                  <SelectS.Option key={_id}>{fullName}</SelectS.Option>
                ))}
              </SelectS.OptGroup>
            )}
            {participantsOptions.users.length > 0 && (
              <SelectS.OptGroup label="Users">
                {participantsOptions.users.map(({ _id, fullName }) => (
                  <SelectS.Option key={_id}>{fullName}</SelectS.Option>
                ))}
              </SelectS.OptGroup>
            )}
          </SelectS>)}
        </FormItem>
      </Col>

      <Col span={24}>
        <FormItem label="Additional info">
          {getFieldDecorator('meetingInfo', {
            initialValue: '',
          })(<ReactQuillWrapped
            height="100px"
            withPaddings
            placeholder="Enter text here"
            theme="snow"
            bounds="#text"
            scrollingContainer="#text"
          />)}
        </FormItem>
      </Col>
    </Row>
  </FormS>
);

MeetingNotesForm.propTypes = {
  form: object.isRequired,
  showForm: bool.isRequired,
  onAssignMeClick: func.isRequired,
  onParticipantSearch: func.isRequired,
  participantsOptions: object.isRequired,
  setParticipantsOptions: func.isRequired,
  isSearchingParticipants: bool.isRequired,
};

export { MeetingNotesForm };



// WEBPACK FOOTER //
// ./src/modals/add-meeting-notes-modal/meeting-notes-form/index.js